const layers = [
  {
    id: "L01 / DATA",
    title: "The corpus",
    description:
      "5M+ profiles, refreshed with 100K+ new inbound CVs monthly, cleaned and structured so nothing sits idle in a folder.",
  },
  {
    id: "L02 / MATCH",
    title: "The engine",
    description:
      "AI reads a requirement the way a senior recruiter would — skills, seniority, context — and scores our full pool against it in real time.",
  },
  {
    id: "L03 / RANK",
    title: "The shortlist",
    description:
      "Candidates arrive ranked and explained, so you know why someone made the list before you open their profile.",
  },
  {
    id: "L04 / DESK",
    title: "The handoff",
    description:
      "Our recruiters take it from there — outreach, screening, close. You get a placement, not a login to manage.",
  },
];

export const AILayers = () => {
  return (
    <section className="qh-layers" id="layers">
      <div className="qh-wrap">

        <div className="qh-section-head">
          <span className="qh-tag">
            // What's running behind your shortlist
          </span>

          <h2>
            Four layers our recruiters use.
            <br />
            You never have to log into any of them.
          </h2>

          <p>
            This is the actual process behind every shortlist we send —
            built and operated entirely by our team, so all you deal
            with is the outcome.
          </p>
        </div>

        <div className="qh-layer-list">
          {layers.map((layer) => (
            <div className="qh-layer" key={layer.id}>

              <div className="qh-layer-index">
                {layer.id}
              </div>

              <div>
                <h3>{layer.title}</h3>
              </div>

              <div>
                <p>{layer.description}</p>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};